import { useEffect, useState, useTransition } from "react"
import { ModuleEnum, useLazyGetUtilitiesQuery } from "src/api/modules/utilitize"
import InputAutocomplete from "src/shared/components/input-autocomplete"

interface SelectContainerTypeFieldProps {
  value: string
  onChange: (value: string, valueObj: any) => void
  label?: string
  fullWidth?: boolean
  placeholder?: string
  required?: boolean
  helperText?: string
  error?: boolean
  disableClearable?: boolean
}

const SelectContainerTypeField = ({
  value,
  onChange,
  label,
  placeholder,
  fullWidth = true,
  required = false,
  helperText,
  disableClearable = false,
  error
}: SelectContainerTypeFieldProps) => {
  const [isContainerTypePending, startContainerTypeTransition] = useTransition()
  const [containerType, setContainerType] = useState<IOptions[]>([])

  const [getUtilities] = useLazyGetUtilitiesQuery()
  const handleGetContainerType = async () => {
    startContainerTypeTransition(async () => {
      const response = await getUtilities({
        page: 1,
        limit: 10000,
        active: true,
        module: ModuleEnum.CONTAINER_TYPE
      })
      startContainerTypeTransition(() => {
        setContainerType(
          response.data?.data?.map(item => ({
            value: item.id ?? "",
            label: item.itemName ?? ""
          })) ?? []
        )
      })
    })
  }

  useEffect(() => {
    if (value && !containerType.length) {
      handleGetContainerType()
    }
  }, [value])

  return (
    <InputAutocomplete
      label={label}
      loading={isContainerTypePending}
      fullWidth={fullWidth}
      loadingText="Loading Container Type..."
      options={containerType}
      getOptionLabel={item => item.label ?? ""}
      getOptionKey={item => item.value ?? ""}
      onOpen={() => !containerType.length && handleGetContainerType()}
      value={containerType.find(item => item.value === value)}
      placeholder={placeholder}
      onChange={(value: any) => {
        onChange(value?.value, value)
      }}
      required={required}
      helperText={helperText}
      error={error}
      disableClearable={disableClearable}
    />
  )
}

export default SelectContainerTypeField
